module.exports = __webpack_public_path__ + "img/floor_OG1.0bb2cbbb.svg";